import React from 'react';
import { formatXml } from '../utils/xmlHelpers';

const LightningIcon = ({ className = "w-5 h-5" }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor">
    <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" />
  </svg>
);

const XmlPreviewModal = ({ isOpen, onClose, xmlContent }) => {
  if (!isOpen) return null;
  
  const copyToClipboard = () => {
    navigator.clipboard.writeText(xmlContent);
    alert("XML copied to clipboard!");
  };
  
  return (
    <div className="fixed inset-0 bg-black/70 z-50 flex items-center justify-center p-4">
      <div className="bg-gray-800 rounded-lg shadow-xl w-full max-w-3xl flex flex-col max-h-[90vh] border border-gray-700">
        <div className="p-4 border-b border-gray-700 bg-gray-900 rounded-t-lg flex justify-between items-center">
          <div className="flex items-center gap-2">
            <LightningIcon className="w-5 h-5 text-yellow-400" />
            <h3 className="font-bold text-white">XML Payload Preview</h3>
          </div>
          <button onClick={onClose} className="text-gray-400 hover:text-white text-xl font-bold px-2">×</button>
        </div>
        
        <div className="p-4 overflow-auto flex-1 bg-gray-900">
          <pre className="text-xs text-green-400 font-mono whitespace-pre-wrap break-all">{formatXml(xmlContent)}</pre>
        </div>
        
        <div className="p-4 border-t border-gray-700 bg-gray-900 flex justify-end gap-2 rounded-b-lg">
          <button onClick={copyToClipboard} className="px-4 py-2 bg-yellow-500/20 text-yellow-400 rounded font-medium hover:bg-yellow-500/30 border border-yellow-500/30">
            Copy to Clipboard
          </button>
          <button onClick={onClose} className="px-4 py-2 bg-gray-600 text-white rounded font-medium hover:bg-gray-500">
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default XmlPreviewModal;